import fetch from "cross-fetch";
import getAPIPrefix from "../lib/api_prefix";
import { stringify } from "querystring";
import { getUserTimezone } from "../lib/timezones";
import get from "lodash/get";

function fetchDownloads(filters, user) {
  if (!get(filters, "timezone")) {
    filters.timezone = getUserTimezone();
  }
  return fetchStats("downloads", filters, user);
}

function fetchInsertions(filters, user) {
  if (!get(filters, "timezone")) {
    filters.timezone = getUserTimezone();
  }
  return fetchStats("insertions", filters, user);
}

function fetchStats(endpoint, filters, user) {
  var query = stringify(filters);
  return fetch(getAPIPrefix() + "stats/" + endpoint + "?" + query, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + user.authToken,
    },
  });
}

const statsAPI = {
  fetchDownloads,
  fetchInsertions,
};

export default statsAPI;
